var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.56 39.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.14,8.73a6.45,6.45,0,0,0-4.7,2,7.12,7.12,0,0,0,0,9.77L19.79,31.39a.7.7,0,0,0,1,0L31.12,20.54a7.11,7.11,0,0,0,0-9.77,6.46,6.46,0,0,0-9.41,0l-1.43,1.48-1.43-1.49a6.35,6.35,0,0,0-4.71-2Zm0,1.33a5.12,5.12,0,0,1,3.74,1.64l1.92,2a.69.69,0,0,0,1,0l1.9-2a5.07,5.07,0,0,1,7.47,0,5.76,5.76,0,0,1,0,7.9L20.28,30,10.41,19.6a5.76,5.76,0,0,1,0-7.9,5.13,5.13,0,0,1,3.73-1.65Z",
    style: {
      fill: "#010101"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.e211a1a86d932edc3b72c661b788a553.svg";
export { ForwardRef as ReactComponent };